export const useRedirectAfterLogin = () => {
  const saveCurrentPath = (path?: string) => {
    const currentPath = path || window.location.pathname;
    if (currentPath !== '/' && currentPath !== '/login') {
      sessionStorage.setItem('redirectAfterLogin', currentPath);
    }
  };

  const getRedirectPath = (): string => {
    return sessionStorage.getItem('redirectAfterLogin') || '/menu';
  };

  const clearRedirectPath = () => {
    sessionStorage.removeItem('redirectAfterLogin');
  };

  const redirectAfterLogin = (navigate: (path: string) => void) => {
    const redirectTo = getRedirectPath();
    clearRedirectPath();
    navigate(redirectTo);
  };

  return {
    saveCurrentPath,
    getRedirectPath,
    clearRedirectPath,
    redirectAfterLogin
  };
};